import { useState } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IosShare from '@mui/icons-material/IosShare';
import ProfileShareModal from '../views/userProfile/ProfileShareModal';

const CopyToClipboardButton = ({
  copyLink,
  buttonProps,
  profileName,
  profileBio,
  showSocialSharing = false,
}: {
  copyLink: string;
  buttonProps: ButtonProps;
  profileName?: string;
  profileBio?: string;
  showSocialSharing?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const handleClick = () => {
    if (showSocialSharing) {
      setShowShareModal(true);
    } else {
      setOpen(true);
      if (copyLink) {
        navigator?.clipboard?.writeText?.(copyLink);
      }
    }
  };

  const { sx, ...restButtonProps } = buttonProps;

  // Helper function to apply !important
  const applyImportant = (styles: Record<string, any>) =>
    Object.keys(styles).reduce((acc, key) => {
      acc[key] = `${styles[key]} !important`;
      return acc;
    }, {} as Record<string, any>);

  return (
    <>
      {
        !!copyLink &&
        <>
          <Button
            id="button-share-persona"
            variant="outlined"
            color='secondary'
            size="large"
            sx={{
              ...applyImportant({
                px: '8px',
                minWidth: 0,
                ...sx,
              }),
            }}
            onClick={handleClick}
            {...restButtonProps}
          >
            <IosShare sx={{color: (theme) => theme.palette.secondary.contrastText}}/>
          </Button>
          
          {showSocialSharing ? (
            <ProfileShareModal
              open={showShareModal}
              onClose={() => setShowShareModal(false)}
              profileUrl={copyLink}
              profileName={profileName}
              profileBio={profileBio}
            />
          ) : (
            <Snackbar
              open={open}
              onClose={() => setOpen(false)}
              autoHideDuration={2000}
              message="Copied to clipboard"
            />
          )}
        </>
      }
    </>
  );
};

export default CopyToClipboardButton;
